import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { OpeningService } from 'src/app/api/money/opening.service';
import { GeneralService } from 'src/app/api/config/general.service';
import { constants } from 'src/app/constants';
import { ToolsService } from 'src/app/utils/tools.service';
import { IncomeService } from 'src/app/api/money/income.service';
import { AmountTextService } from 'src/app/utils/amount-text.service';
import { AccountbankService } from 'src/app/api/finance/accountbank.service';
import { ConceptIncomeExtendsComponent } from 'src/app/config/concept-income/concept-income-extends/concept-income-extends.component';
declare var $: any;

@Component({
  selector: 'app-income-form',
  templateUrl: './income-form.component.html',
  styleUrls: ['./income-form.component.css']
})
export class IncomeFormComponent implements OnInit {
  @ViewChild(ConceptIncomeExtendsComponent) ConceptIncomeExtendsComponent: any;

  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // variables
  check_moneybox: boolean = false;
  boxselected: any = null;
  moneybox: any = null;
  validatealert: boolean = false;

  concepts: any = [];
  currencies: any = [];
  paymentmethods: any = [];
  accountbanks: any = [];
  userpositions: any = constants.USER.TYPES;

  user_client: any = constants.USER.TYPES[0];
  user_provider: any = constants.USER.TYPES[1];
  user_employee: any = constants.USER.TYPES[2];
  user_guide: any = constants.USER.TYPES[3];
  user_transport: any = constants.USER.TYPES[4];
  user_agency: any = constants.USER.TYPES[5];
  user_hotel: any = constants.USER.TYPES[6];
  user_collaborator: any = constants.USER.TYPES[7];

  positionSelected: any = this.user_client.id;
  isPositionSelected: boolean = false;
  possitionValue: any = {};
  paymentMethodSelected: any = {};

  constructor(
    public fb: FormBuilder,
    private el: ElementRef,
    private renderer: Renderer2,
    private router: Router,
    private route: ActivatedRoute,
    private globalService: GlobalService,
    private openingService: OpeningService,
    private generalService: GeneralService,
    private accountbankService: AccountbankService,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private incomeService: IncomeService,
    private amountTextService: AmountTextService,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      currency_id: [null, [Validators.required]],
      concept_id: [null, [Validators.required]],
      paymentmethod_id: [
        constants.paymentmethod_init_id,
        [Validators.required]
      ],
      reference_emisor_receptor_id: [null],
      client_id: [null],
      provider_id: [null],
      employee_id: [null],
      guide_id: [null],
      transport_id: [null],
      agency_id: [null],
      hotel_id: [null],
      collaborator_id: [null],
      accountbank_id: [null],
      gloss: [null, [Validators.required]],
      amount: [null],
      text_amount: [null],
      reference_operation: [null],
      change_amount: [null]
    });
  }

  ngOnInit() {
    this.checkBoxSelected();
    this.getCurrencies();
    this.getAccountBanks();
    this.getConceptIncomes();
    this.getPaymentmethods();

    (<any>$('[data-toggle="tooltip"]')).tooltip();
    this.navigationTrackerService.initializeMenu(this.route);
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  checkBoxSelected() {
    let val_params = '';
    this.openingService.getCheckBoxSlected(val_params).subscribe({
      next: (data: any) => {
        if (!_.isNull(data.data)) {
          this.boxselected = data.data;
          this.getBoxOpening();
        }
      }
    });
  }

  getBoxOpening() {
    this.openingService.getBoxOpening(this.boxselected.id).subscribe({
      next: (data: any) => {
        this.validatealert = true;
        if (data.data) {
          this.check_moneybox = true;
          this.moneybox = data.data;
        }
      }
    });
  }

  getCurrencies() {
    this.generalService.listCurrencies().subscribe({
      next: (data: any) => {
        this.currencies = data.results;
        for (let i in this.currencies) {
          if (this.currencies[i].is_principal) {
            this.item.patchValue({
              currency_id: this.currencies[i].id
            });
          }
        }
      }
    });
  }

  getAccountBanks() {
    this.accountbankService.all().subscribe({
      next: (data: any) => {
        this.accountbanks = data.results;
      }
    });
  }

  getConceptIncomes() {
    this.generalService.listConceptIncomes().subscribe({
      next: (data: any) => {
        this.concepts = data.results;
      }
    });
  }

  getPaymentmethods() {
    this.generalService.listPaymentmethods().subscribe({
      next: (data: any) => {
        this.paymentmethods = data.results;
        this.changePaymentMethod();
      }
    });
  }

  changePaymentMethod() {
    let obj_ = this.toolsService.searchArrById(
      this.item.value.paymentmethod_id,
      this.paymentmethods
    );
    this.paymentMethodSelected = obj_;

    if (!this.paymentMethodSelected.associate_bank) {
      this.item.patchValue({
        accountbank_id: null,
        reference_operation: null
      });
    }
  }

  changeBankAccount(param: any) {
    let value_ = param.value;
    if (value_ == 'null') {
      value_ = null;
    }
    this.item.patchValue({
      accountbank_id: value_
    });
  }

  selectedClientSearch(item_: any) {
    this.isPositionSelected = true;
    this.possitionValue = item_;
    (<any>$('#positionSelected')).attr('disabled', true);
    this.item.patchValue({
      client_id: item_.id,
      reference_emisor_receptor_id: this.positionSelected
    });
  }

  selectedProviderSearch(item_: any) {
    this.isPositionSelected = true;
    this.possitionValue = item_;
    (<any>$('#positionSelected')).attr('disabled', true);
    this.item.patchValue({
      provider_id: item_.id,
      reference_emisor_receptor_id: this.positionSelected
    });
  }

  selectedEmployeeSearch(item_: any) {
    this.isPositionSelected = true;
    this.possitionValue = item_;
    (<any>$('#positionSelected')).attr('disabled', true);
    this.item.patchValue({
      employee_id: item_.id,
      reference_emisor_receptor_id: this.positionSelected
    });
  }

  selectedGuideSearch(item_: any) {
    this.isPositionSelected = true;
    this.possitionValue = item_;
    (<any>$('#positionSelected')).attr('disabled', true);
    this.item.patchValue({
      guide_id: item_.id,
      reference_emisor_receptor_id: this.positionSelected
    });
  }

  selectedTransportSearch(item_: any) {
    this.isPositionSelected = true;
    this.possitionValue = item_;
    (<any>$('#positionSelected')).attr('disabled', true);
    this.item.patchValue({
      transport_id: item_.id,
      reference_emisor_receptor_id: this.positionSelected
    });
  }

  selectedAgenciesSearch(item_: any) {
    this.isPositionSelected = true;
    this.possitionValue = item_;
    (<any>$('#positionSelected')).attr('disabled', true);
    this.item.patchValue({
      agency_id: item_.id,
      reference_emisor_receptor_id: this.positionSelected
    });
  }

  selectedHotelSearch(item_: any) {
    this.isPositionSelected = true;
    this.possitionValue = item_;
    (<any>$('#positionSelected')).attr('disabled', true);
    this.item.patchValue({
      hotel_id: item_.id,
      reference_emisor_receptor_id: this.positionSelected
    });
  }

  selectedCollaboratorsSearch(item_: any) {
    this.isPositionSelected = true;
    this.possitionValue = item_;
    (<any>$('#positionSelected')).attr('disabled', true);
    this.item.patchValue({
      collaborator_id: item_.id,
      reference_emisor_receptor_id: this.positionSelected
    });
  }

  removePositionSelected() {
    this.isPositionSelected = false;
    this.possitionValue = {};
    (<any>$('#positionSelected')).attr('disabled', false);
    this.item.patchValue({
      reference_emisor_receptor_id: null,
      client_id: null,
      provider_id: null,
      employee_id: null,
      guide_id: null,
      transport_id: null,
      agency_id: null,
      hotel_id: null,
      collaborator_id: null
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }

    this.item.patchValue({
      text_amount: this.amountTextService.letras(this.item.value.amount)
    });

    let data: any = {};

    if (this.validate()) {
      data.item = this.item.value;
      data.branchoffice_slug = this.branchofficeSlug;

      if (this.isEdit) {
      } else {
        this.incomeService.save(data).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.router.navigate([
              this.branchofficeSlug + '/caja/ingresos/lista'
            ]);
          }
        });
      }
    }
  }

  validate() {
    return true;
  }

  resetForm() {
    this.submitted = false;
    this.item.reset();
    (<any>$('#item_description')).focus();
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/caja/ingresos/lista']);
  }

  extendsConceptIncome(event: any): void {
    console.log(event);
    this.getConceptIncomes();
    this.item.patchValue({
      concept_id: event.id
    });
  }
}
